import React, { ChangeEvent, KeyboardEvent, useRef, useState } from "react";
import ImageSuccsesSvg from "../../assets/taiga-uikit/icons/document-cloud.svg?react";
import ImageUploadSvg from "../../assets/taiga-uikit/icons/document-upload.svg?react";
import { _colorText, _size, _sizeText, _typeLabel } from "../../core/core";
import { Label } from "../texts/label";
import { Text } from "../texts/text";
import "./InputImage.css";

interface InputImageProps {
  size?: _size;
  labelOutside?: string;
  label?: string;
  placeholder?: string;
  description?: string;
  rightText?: string;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  value?: File | null;
  setValue?: (value: File) => void;
  focusStart?: boolean;
  validation?: () => string;
  errorMessage?: string;
}

export const InputImage: React.FC<InputImageProps> = ({
  size = _size.M,
  labelOutside,
  label,
  placeholder,
  description,
  rightText,
  onKeyDown,
  value = null,
  setValue,
  focusStart = false,
  validation,
  errorMessage = "",
}) => {
  const [focus, setFocus] = useState<boolean>(focusStart);
  const [messageError, setMessageError] = useState<string>(errorMessage);
  const inputElement = useRef<HTMLInputElement>(null);
  const variantsClassName = (): string => {
    return validation && messageError !== ""
      ? `input-field-image input-field-${size}-image error`
      : `input-field-image input-field-${size}-image`;
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    console.log("handleChange");
    if (validation) setMessageError(validation());
    if (setValue && event.target.files) {
      setValue(event.target.files[0]);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    return false;
  };

  return (
    <div className="field" onClick={handleClick}>
      {labelOutside && (
        <Text size={_sizeText.xs} color={_colorText.neutral}>
          {labelOutside}
        </Text>
      )}
      <div className={variantsClassName()}>
        {description && (
          <Text size={_sizeText.xs} color={_colorText.neutral}>
            {description}
          </Text>
        )}
        <div className="field-content-file">
          {placeholder ? (
            <Label size={size} type={_typeLabel.input}>
              {placeholder}
            </Label>
          ) : (
            <Label size={size} type={_typeLabel.input}>
              Прикрепить фото
            </Label>
          )}
          <input
            type="file"
            accept="image/*"
            placeholder={placeholder || label}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            ref={inputElement}
          />
        </div>
        {rightText && (
          <div className="right-content-image">
            <Text size={_sizeText.xs} color={_colorText.neutral}>
              {description}
            </Text>
          </div>
        )}
        {value ? <ImageSuccsesSvg /> : <ImageUploadSvg />}
      </div>
      {description && (
        <Text size={_sizeText.xs} color={_colorText.neutral}>
          {description}
        </Text>
      )}
      {messageError && (
        <Text size={_sizeText.xs} color={_colorText.negative}>
          {messageError}
        </Text>
      )}
    </div>
  );
};
